import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {DataSourceFacade} from '../../../data-source/facade/data-source.facade';

@Component({
  selector: 'morva-data-source-in-dashboards',
  templateUrl: './data-source-in-dashboards.component.html',
  styleUrls: ['./data-source-in-dashboards.component.scss'],
})
export class DataSourceInDashboardsComponent implements OnInit, OnDestroy {
  @Input() workspaceId: string;
  @Input() dataSources: string[];
  subscriptions: Subscription[] = [];
  usedDashboards = [];

  constructor(private dataSourceFacade: DataSourceFacade) {
  }

  ngOnInit(): void {
    this.initActions();
    this.initListeners();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private initActions() {
    this.checkDeleteDataSource();
  }

  private initListeners() {
    this.subscriptions.push(this.dataSourceFacade.getUsedDashboards$().subscribe(dashboards => {
      this.usedDashboards = dashboards || [];
    }));
  }

  private checkDeleteDataSource() {
    this.dataSourceFacade.checkDeleteDataSource(this.workspaceId, this.dataSources);
  }
}
